// removed by extract-text-webpack-plugin
module.exports = {"table":"merge-grid__table___2J7FR","td":"merge-grid__td___MxVst","td__active":"merge-grid__td__active___3XYiQ","tr":"merge-grid__tr___aqB9_","thead":"merge-grid__thead___28mIk","th":"merge-grid__th___22bEK","selected-row":"merge-grid__selected-row___2uQG4"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/documents/merge-grid.scss
// module id = 1330
// module chunks = 0